import { z } from 'zod/v3';

export const AlgorithmMappingQueryDtoSchema = z.object({
  id: z.number(),
  algorithmSourceId: z.number(),
  algorithmSourceAlias: z.string().nullish(),
  algorithmSourcePeriodOffset: z.number().nullish(),
  dataObjectDescriptionCode: z.string().nullish(),
  dataSourceCode: z.string().nullish(),
  classifierMappingId: z.number(),
  classifierMappingCode: z.string(),
  classifierMappingName: z.string(),
  classifierIdFrom: z.number(),
  classifierFromCode: z.string(),
  classifierIdTo: z.number(),
  classifierToCode: z.string(),
  sourceDimension: z.string(),
  alias: z.string(),
  joinTypeCode: z.string(),
});
